/** Gemeinsame Ledger WebUSB-Hilfen (Modal + LedgerConnect) */

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const isLedgerUsbBusyError = (error) => {
  const raw = `${error?.name || ""} ${error?.message || error || ""}`;
  return /claimInterface|Unable to claim interface|TransportInterfaceNotAvailable|LIBUSB_ERROR_BUSY|already open/i.test(
    raw
  );
};

export const isLedgerUsbResetError = (error) => {
  const raw = `${error?.name || ""} ${error?.message || error || ""}`;
  return /Failed to execute 'reset' on 'USBDevice'|Unable to reset the device/i.test(raw);
};

export const mapLedgerErrorMessage = (error, language) => {
  const raw = `${error?.name || ""} ${error?.message || error || ""}`;

  if (isLedgerUsbBusyError(error) || isLedgerUsbResetError(error)) {
    return language === "en"
      ? "Ledger is currently used by another app, browser tab, or Ledger Live. Please close Ledger Live and other wallet tabs, reconnect the device if needed, unlock it, open the VeChain app, and try again."
      : "Ledger wird aktuell von einer anderen App, einem anderen Browser-Tab oder Ledger Live verwendet. Bitte schließen Sie Ledger Live und andere Wallet-Tabs, verbinden Sie das Gerät bei Bedarf neu, entsperren Sie es, öffnen Sie die VeChain-App und versuchen Sie es erneut.";
  }

  if (raw.includes("Connection to Ledger Live failed") || raw.includes("Verbindung zu Ledger Live fehlgeschlagen")) {
    return raw;
  }

  if (raw.includes("Transport not supported")) {
    return language === "en"
      ? "Ledger not supported in this browser"
      : "Ledger wird in diesem Browser nicht unterstützt";
  }

  if (raw.includes("No device selected")) {
    return language === "en" ? "Ledger device not found" : "Ledger-Gerät nicht gefunden";
  }

  if (raw.includes("0x6a80")) {
    return language === "en" ? "Ledger is locked. Please unlock it." : "Ledger ist gesperrt. Bitte entsperren Sie es.";
  }

  if (raw.includes("0x6a82")) {
    return language === "en" ? "VeChain app not open on Ledger" : "VeChain-App ist nicht auf dem Ledger geöffnet";
  }

  if (raw.includes("0x6a84")) {
    return language === "en" ? "Only VeChain wallets supported" : "Nur VeChain-Wallets werden unterstützt";
  }

  if (raw.includes("Invalid VeChain address format")) {
    return language === "en"
      ? "Invalid VeChain address format. Please ensure the VeChain app is open on Ledger."
      : "Ungültiges VeChain-Adressformat. Bitte stellen Sie sicher, dass die VeChain-App auf dem Ledger geöffnet ist.";
  }

  return language === "en"
    ? "Failed to connect to Ledger. Please check your device and try again."
    : "Verbindung zu Ledger fehlgeschlagen. Bitte überprüfen Sie Ihr Gerät und versuchen Sie es erneut.";
};
